import { createSlice } from '@reduxjs/toolkit';

const deadlineDocumentSlice = createSlice({
  name: 'deadlineDocumentSlice',
  initialState: {
    data: [],
    signatureAllDocument: false,
  },
  reducers: {
    setSignature: (state, action) => {
      state.signatureAllDocument = action.payload;
    },
  },
});

export const { setSignature } = deadlineDocumentSlice.actions;

export default deadlineDocumentSlice.reducer;
